const actions = {
  SET_STATE: 'city/SET_STATE',
  LOAD_CURRENT_CITY: 'city/LOAD_CURRENT_CITY',
}

export default actions
